import MainNavBarUserData from './MainNavBarUserData'

export default MainNavBarUserData
